export const GRADE_SUBMIT_ANSWER = 'GRADE_SUBMIT_ANSWER';
export const GRADE_SUBMIT_ANSWER_SUCCESS = 'GRADE_SUBMIT_ANSWER_SUCCESS';
export const GRADE_SUBMIT_ANSWER_FAILURE = 'GRADE_SUBMIT_ANSWER_FAILURE';

export const GRADE_BEGIN = 'GRADE_BEGIN';
export const GRADE_BEGIN_SUCCESS = 'GRADE_BEGIN_SUCCESS';
export const GRADE_BEGIN_FAILURE = 'GRADE_BEGIN_FAILURE';

export const GRADE_FINISH = 'GRADE_FINISH';
export const GRADE_FINISH_SUCCESS = 'GRADE_FINISH_SUCCESS';
export const GRADE_FINISH_FAILURE = 'GRADE_FINISH_FAILURE';

export const GRADE_RETAKE = 'GRADE_RETAKE';
export const GRADE_RETAKE_SUCCESS = 'GRADE_RETAKE_SUCCESS';
export const GRADE_RETAKE_FAILURE = 'GRADE_RETAKE_FAILURE';

export const GRADE_MARK_COMPLETE = 'GRADE_MARK_COMPLETE';
export const GRADE_MARK_COMPLETE_SUCCESS = 'GRADE_MARK_COMPLETE_SUCCESS';
export const GRADE_MARK_COMPLETE_FAILURE = 'GRADE_MARK_COMPLETE_FAILURE';

export const GRADE_LOAD_GRADEBOOK = 'GRADE_LOAD_GRADEBOOK';
export const GRADE_LOAD_GRADE_RESPONSES = 'GRADE_LOAD_GRADE_RESPONSES';
